import React, { useState } from 'react';
import { toast } from 'sonner';
import { AlertTriangle, CheckCircle2, Loader2, ScanSearch } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { runAiJob } from '../../lib/aiJob';

const TONE = { alta: 'border-rose-500/50 bg-rose-500/10 text-rose-100', media: 'border-amber-500/50 bg-amber-500/10 text-amber-100', baja: 'border-slate-600 bg-slate-800/40 text-slate-300' };

// Recusación sugerida: possible implicancia/recusación of the magistrates hearing the case (auto on sala/judge change)
export const RecusalPanel = ({ matter, onUpdated }) => {
  const { api } = useAuth();
  const [busy, setBusy] = useState(false);
  const r = matter.recusal_check;
  const run = async () => {
    setBusy(true);
    try { await runAiJob(api, `/courts/matters/${matter.id}/recusal`, {}, { timeout: 180000 }); onUpdated(); } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  return (
    <div data-testid={`recusal-panel-${matter.id}`} className="mt-2">
      <div className="flex flex-wrap items-center gap-2">
        {r && !r.alertas.length && <span data-testid={`recusal-clear-${matter.id}`} className="flex items-center gap-1 text-[11px] text-emerald-300"><CheckCircle2 className="h-3 w-3" />Sin causales de implicancia o recusación detectadas</span>}
        {r?.alertas?.length > 0 && <span data-testid={`recusal-count-${matter.id}`} className="flex items-center gap-1 text-[11px] font-semibold text-rose-300"><AlertTriangle className="h-3 w-3" />{r.alertas.length} posible(s) causal(es)</span>}
        <button type="button" data-testid={`recusal-run-${matter.id}`} onClick={run} disabled={busy} className="flex items-center gap-1 rounded-full border border-slate-600 px-2.5 py-0.5 text-[11px] text-slate-300 hover:border-amber-500 disabled:opacity-60">
          {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <ScanSearch className="h-3 w-3" />}{busy ? 'Revisando...' : 'Revisar recusación'}
        </button>
      </div>
      {r?.alertas?.map((a, i) => (
        <div key={i} data-testid={`recusal-alert-${i}`} className={`mt-1.5 rounded-lg border p-2 text-[11px] ${TONE[a.gravedad] || TONE.baja}`}>
          <p className="font-semibold">{a.judge_name} · {a.tipo === 'implicancia' ? 'Implicancia' : 'Recusación'} ({a.gravedad}) · {a.articulo}</p>
          <p>{a.causal}. {a.fundamento}</p>
          <p className="opacity-80"><b>Qué hacer:</b> {a.accion}</p>
        </div>
      ))}
    </div>
  );
};
